import React, { useState  } from "react";
import authHeader from "../services/AuthHeader";
import axios from 'axios';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './style.css';
import {
    Button,
    FormControl,
  } from 'react-bootstrap';

const Validate = (props) => {
    const [studentUuid,setStudentUuid] = useState();
    const [showResult,setShowResult] = useState(false);
    const [voteResults,setVoteResults] = useState([]);

    /* Get ballots based on UUID */
    const onSubmit = (e) => {
      e.preventDefault();
      axios
        .get(process.env.REACT_APP_API_BASE + "votingresultsuuid/"+studentUuid, {
          headers: authHeader(),
        })
        .then((res) => {
          setVoteResults(res.data);
          setShowResult(true);
        });
    };
    /* select text when focues */ 
    const handleFocus = (event) => event.target.select();
    let ballotName = '';
    let ballotNameShow = true;
return  (
    <>
    <h1 className='h2'>Validate Vote</h1>
    <form onSubmit={onSubmit}>
    <label className='sr-only' htmlFor='student-uuid'>
      Voting record UUID
    </label>
    <FormControl
         id='student-uuid'
         type='text'
         placeholder='Enter the UUID'
         aria-label='Voting record UUID'
         value = {studentUuid}
         style={{ width: '100%', height: '40px'}}
         onFocus={handleFocus}
         onInput={e => setStudentUuid(e.target.value)}
    />
    <Button
          className='btn btn-default'
          type='submit'
          style={{ marginTop: '40px' }}
      >
      Validate!
      </Button>
      </form>
      { showResult ? (
          <div style={{ marginTop: '30px'}} aria-live='polite'>
            <h2 className='h3'>Vote Record</h2>
            <table>
              <caption className='sr-only'>Vote validation results</caption>
              <tbody>
                <tr>
                  <td>This is a record of your votes</td>
                </tr>
                <tr>
                  <td>
                    Random ID: <b>{studentUuid}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    We do not match this ID to any identifier, your vote is
                    anonymous.
                  </td>
                </tr>
                <tr>
                  <td>
                    This ID can be used to check the integrity of your vote
                  </td>
                </tr>
       
                { voteResults.length ? voteResults.map((ballot, i) => {
                    if (ballotName !== ballot.ballotName){
                      ballotName = ballot.ballotName;
                      ballotNameShow = true;
                    } else {
                      ballotNameShow = false;
                    }
                    return(
                    <>
                    { ballotNameShow ? (
                    <tr key={'ballot_name_ '+i}>
                          <td>
                          <div style={{marginTop: '20px'}}>
                            <b>{ballot.ballotName}</b>
                            </div>
                          </td>
                        </tr>) : ''}
                        <tr key={'ballot_details_ '+i}>
                            <td>
                                {ballot.ballotCandidateName ? ballot.ballotCandidateName : ballot.candidateName}
                                {ballot.ballotCandidatePartyName ? ' - ' + ballot.ballotCandidatePartyName : (
                                  (!ballot.writeIn ? (ballot.referendum ? '' : ' - Independent'): ' - Write In')
                                 )}
                            </td>
                        </tr>
                    </>)
                }) : (
                  <tr>
                    <td>No results available for this UUID.</td>
                  </tr>
                )} 
              </tbody>
            </table>
          </div>
      ) : null}
    </>
    )
}

export default Validate;
